module.exports = __webpack_public_path__ + "static/images/containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/crewBookNational/cn/CREW_BOOK_NATIONAL_sweden_cn.c8f4f514.png";


//////////////////
// WEBPACK FOOTER
// ./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/crewBookNational/cn/CREW_BOOK_NATIONAL_sweden_cn.png
// module id = 1213
// module chunks = 16